// [Phase 30] Tech Insights scorecard cards for entity pages
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityTechInsightsScorecardCard } from '@backstage-community/plugin-tech-insights';

export const Iso27001ScorecardCard = () => {
  const { entity } = useEntity();
  const isAgent = entity.spec?.type === 'agent';
  if (isAgent) return null;
  return (
    <EntityTechInsightsScorecardCard
      title="ISO 27001 — Information Security"
      description="Live-backed compliance checks. Each row cites a Prometheus metric or K8s API call."
      checksId={[
        'has-network-policy',
        'has-liveness-probe',
        'logs-shipping-active',
        'audit-events-flowing',
        'rbac-sa-bound',
      ]}
    />
  );
};

export const Iso42001ScorecardCard = () => {
  const { entity } = useEntity();
  const isAgent = entity.spec?.type === 'agent';
  if (!isAgent) return null;
  return (
    <EntityTechInsightsScorecardCard
      title="ISO 42001 — AI Management System"
      description="Live checks reading the AISystem CRD record for this agent."
      checksId={[
        'has-owner',
        'has-policy-ref',
        'tools-declared',
        'lifecycle-active',
      ]}
    />
  );
};

export const EuAiActScorecardCard = () => {
  const { entity } = useEntity();
  const isAgent = entity.spec?.type === 'agent';
  if (!isAgent) return null;
  return (
    <EntityTechInsightsScorecardCard
      title="EU AI Act — Risk Classification"
      description="NOT_MEASURABLE until risk classification is approved via ADR."
      checksId={['eu-aiact-risk-classified', 'eu-aiact-adr-cited']}
    />
  );
};
